export const CHAR_LENGTH = 20;

export const formatLength = (text, char_len = CHAR_LENGTH) => {
  if (text.length <= char_len) return text;

  return text.substring(0, char_len) + '...';
};
